import { createApp } from 'utils/vue';
import App from "components/pages/contents/container";
import { registerHandler } from "utils/handler";

const handler = (app) => {
  createApp(App).mount("#app-container");
};

registerHandler("contents/index", handler);
